import { html, unsafeCSS } from 'lit';

import { DERElement } from '~/common/der-element';
import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './title.styles';

export class TitleWrapper extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    override render() {
        return html`
            <div class="o-module__module-title">
                <slot></slot>
            </div>
        `;
    }
}
